// POST /api/orgs — the create-organization wire (2026-08-07: the drawer's org
// picker carries the action, and a door ships with its machinery). Same shape
// as every client here: a factory over fetch, refusals relayed verbatim.

import { appFetch } from './transport';
export interface CreatedOrg {
  id: string;
  name: string;
}

export interface OrgsClient {
  createOrg(name: string): Promise<CreatedOrg>;
}

export function createOrgsClient(fetchImpl: typeof fetch = appFetch): OrgsClient {
  return {
    async createOrg(name) {
      const res = await fetchImpl('/api/orgs', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ name }),
      });
      const body = (await res.json().catch(() => null)) as
        | { org?: CreatedOrg; reason?: string }
        | null;
      if (!res.ok || !body?.org) {
        throw new Error(body?.reason ?? `POST /api/orgs answered ${res.status}`);
      }
      return body.org;
    },
  };
}
